import { Pipe, PipeTransform } from '@angular/core';

import { tiposCondicoesPagamento } from '../condicao-pagamento-tipo';

@Pipe({
    name: 'condicaoPagamentoTipo'
})
export class CondicaoPagamentoTipoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = tiposCondicoesPagamento.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return tiposCondicoesPagamento[index].nome;
        }
        return '';
    }
}
